import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';

export const updateMenuSection = async (
  menuId: string,
  sectionId: string,
  body: { name: string; description: string; items: string[] },
): Promise<Response> => {
  try {
    const res = await fetch(`${API_URL}/menus/${menuId}/sections/${sectionId}`, {
      method: 'PUT',
      body: JSON.stringify(body),
      headers: {
        'Content-Type': 'application/json',
      },
    });
    if (!res.ok) throw new Error(res.statusText);
    return res;
  } catch (e) {
    throw new Error('Could not update menu section', { cause: e });
  }
};
